/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const PDFDoc72Icon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 72, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="PDFDoc72Icon"
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              d="M15 36V12C15 10.8954 15.8954 10 17 10H39.1716C39.702 10 40.2107 10.2107 40.5858 10.5858L57.4142 27.4142C57.7893 27.7893 58 28.298 58 28.8284V36M40 10.5V26C40 27.1046 40.8954 28 42 28H57.5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <g opacity="0.4">
              <path
                d="M16 43.584C16 43.248 16.024 42.976 16.072 42.768C16.136 42.56 16.248 42.4 16.408 42.288C16.568 42.176 16.792 42.104 17.08 42.072C17.384 42.024 17.776 42 18.256 42H21.64C22.696 42 23.584 42.088 24.304 42.264C25.04 42.44 25.64 42.736 26.104 43.152C26.568 43.568 26.904 44.12 27.112 44.808C27.32 45.48 27.424 46.312 27.424 47.304C27.424 48.296 27.312 49.144 27.088 49.848C26.864 50.552 26.52 51.128 26.056 51.576C25.592 52.024 24.992 52.352 24.256 52.56C23.536 52.768 22.664 52.872 21.64 52.872H19.12V57.72C19.12 58.04 19 58.328 18.76 58.584C18.52 58.84 18.12 58.968 17.56 58.968C17 58.968 16.6 58.832 16.36 58.56C16.12 58.288 16 58.008 16 57.72V43.584ZM19.12 50.184H21.64C22.664 50.184 23.36 49.96 23.728 49.512C24.112 49.064 24.304 48.336 24.304 47.328C24.304 46.8 24.232 46.368 24.088 46.032C23.96 45.696 23.776 45.432 23.536 45.24C23.296 45.032 23.016 44.896 22.696 44.832C22.376 44.752 22.024 44.712 21.64 44.712H19.12V50.184Z"
                fill="currentColor"
              />
              <path
                d="M35.9907 42C37.2387 42 38.3107 42.216 39.2067 42.648C40.1187 43.064 40.8627 43.648 41.4387 44.4C42.0307 45.136 42.4627 46.016 42.7347 47.04C43.0227 48.048 43.1667 49.144 43.1667 50.328C43.1667 51.592 43.0227 52.744 42.7347 53.784C42.4467 54.808 42.0067 55.688 41.4147 56.424C40.8227 57.16 40.0867 57.728 39.2067 58.128C38.3267 58.528 37.2947 58.728 36.1107 58.728H31.5507C30.9907 58.728 30.6307 58.64 30.4707 58.464C30.3267 58.272 30.2547 58 30.2547 57.648V43.08C30.2547 42.728 30.3267 42.464 30.4707 42.288C30.6147 42.096 30.9747 42 31.5507 42H35.9907ZM33.3747 56.232H36.1107C38.7347 56.232 40.0467 54.24 40.0467 50.256C40.0467 49.344 39.9747 48.528 39.8307 47.808C39.6867 47.088 39.4387 46.488 39.0867 46.008C38.7347 45.512 38.2707 45.136 37.6947 44.88C37.1187 44.624 36.3907 44.496 35.5107 44.496H33.3747V56.232Z"
                fill="currentColor"
              />
              <path
                d="M54.6627 48.744C55.1267 48.744 55.4947 48.856 55.7667 49.08C55.9907 49.304 56.1027 49.648 56.1027 50.112C56.1027 50.592 55.9907 50.936 55.7667 51.144C55.5427 51.336 55.1747 51.432 54.6627 51.432H49.5747V57.984C49.5747 58.208 49.4467 58.424 49.1907 58.632C48.9507 58.856 48.5507 58.968 47.9907 58.968C47.4307 58.968 47.0307 58.856 46.7907 58.632C46.5667 58.424 46.4547 58.208 46.4547 57.984V43.32C46.4547 42.824 46.5827 42.48 46.8387 42.288C47.0947 42.096 47.4787 42 47.9907 42H55.4067C55.8707 42 56.2147 42.104 56.4387 42.312C56.6787 42.504 56.8067 42.848 56.8227 43.344C56.8387 43.84 56.7187 44.192 56.4627 44.4C56.2067 44.592 55.8467 44.688 55.3827 44.688H49.5747V48.744H54.6627Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

PDFDoc72Icon.tags = ['document', 'pdf', 'file', 'download', 'format'];

PDFDoc72Icon.category = '72x72 (File types)';

PDFDoc72Icon.iconSize = 72;
